export class IosInstallCode {
  url!: string;
  store!: string;
}
